/* eslint-disable react/jsx-max-depth */
import React from 'react';
import styled from 'styled-components';
import { SvgWrapper } from '../svg-wrapper';
var Svg = /*#__PURE__*/styled(SvgWrapper).withConfig({
  displayName: "back-button-icon__Svg",
  componentId: "wn8vvn-0"
})(["width:60px;height:70px;color:", ";"], p => p.theme.colors.primary500);
export var BackButton = (_ref) => {
  var {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    viewBox: "0 0 60 70",
    className: className
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "back-button-path-1",
    x: "0",
    y: "0",
    width: "60",
    height: "60",
    rx: "30"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-8.3%",
    width: "116.7%",
    height: "133.3%",
    filterUnits: "objectBoundingBox",
    id: "back-button-filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: "0",
    dy: "10",
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.000000, -1647.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.000000, 1647.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: "1",
    filter: "url(#back-button-filter-2)",
    xlinkHref: "#back-button-path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#back-button-path-1"
  })), /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "33.7834496 21 24.75 30.3336725 33.7834496 39.667345"
  }))))));
};